import { render, staticRenderFns } from "./rightService.vue?vue&type=template&id=432e776c&scoped=true&"
var script = {}
import style0 from "./rightService.vue?vue&type=style&index=0&id=432e776c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432e776c",
  null
  
)

export default component.exports